import { axiosInstance, API_PREFIX, type ApiResponse } from '@/shared/api';
import type { ShopItem, ShopItemListParams } from '../model/types';

export const getItemList = async (params?: ShopItemListParams): Promise<ApiResponse<ShopItem[]>> => {
  const { data } = await axiosInstance.get<ApiResponse<ShopItem[]>>(`${API_PREFIX.ADMIN_V1}/shop/item-list`, {
    params,
  });

  return data;
};
